import { Consolidated, PickingSettingService, PickingSetting, EntityPickingService, EntityPicking } from '../../../../../core';
import { STATE_ORDER_DISPATCH } from '../../../../../picking/picking-shared/enum/state-order-dispatch.enum';
import { Constants } from '../../../../../core';
import { CustomInjector } from '../../../../../core/helpers/inject';
import { environment } from '../../../../../../environments/environment';
import { DataTable } from '../../data-table.interface';
import { SUPERMERCADOS_CODE } from '../../../../../core/configs/company.config';

export const TYPE_CONSOLIDATED = {
  PRINT: 'CONSOLIDATED_PRINT',
  CANCEL: 'CONSOLIDATED_CANCEL',
  ASSIGN: 'CONSOLIDATED_ASSIGN',
  PRINT_HP: 'PRINT_FOIL_PICKING',
  ASSIGN_PICKER: 'ASSIGN_PICKER',
  CUSTOM_ACTION: 'CUSTOM_ACTION'
};

// const VALIDATE_ROLES = (): boolean => {
//   const authService: any = new CustomInjector<AuthService>().get(AuthService);
//   return authService.verifyRoles(ROLES_ADMIN_SUPERVISOR);
// };

export const hasVisibleAssignment = () => {
  const settingService: any = new CustomInjector<PickingSettingService>().get(PickingSettingService);
  const pickingSetting: PickingSetting = settingService.getSettingStorage();
  return pickingSetting.pickingDispatch;
};

export const hasVisiblePickingAssignment = () => {
  const entityService: any = new CustomInjector<EntityPickingService>().get(EntityPickingService);
  return entityService.getSettingStorage();
};


export const conditionPrinter = (item: Consolidated) => {
  switch (item.state) {
    case STATE_ORDER_DISPATCH.PRE_DISPATCH:
    case STATE_ORDER_DISPATCH.CONSOLIDATED:
    case STATE_ORDER_DISPATCH.LOCATED:
    case STATE_ORDER_DISPATCH.DISPATCHED:
      return false;
    default:
      return true;
  }
};

export const conditionPrinterHP = (item: Consolidated) => {
  switch (item.state) {
    case STATE_ORDER_DISPATCH.CREATED:
      return true;
    default:
      return false;
  }
};

export const iconsOfActionsList = [ 
  {
    icon: 'picker',
    tooltip: 'Asignar pedido',
    type: TYPE_CONSOLIDATED.ASSIGN_PICKER,
    hasVisibleCondition: (element: Consolidated[]) => {
      const entities: EntityPicking[] = hasVisiblePickingAssignment();
      const isPickingClient = element.filter(x => {
        let entity = entities.find(e=>e.entityId ===x.entityCode)
        return x.state !== STATE_ORDER_DISPATCH.CREATED || x.pickingClient ||(entity !== undefined && entity.enableAssignment === false)
      }).length > 0
        ? false
        : true;
      return isPickingClient
    }
  }, 
  {
    icon: 'pocket',
    tooltip: 'Asignar despacho',
    type: TYPE_CONSOLIDATED.ASSIGN,
    hasVisibleCondition: (element: Consolidated[]) => {
      return hasVisibleAssignment() === false || element.filter(
        (x: Consolidated) => x.state !== STATE_ORDER_DISPATCH.CREATED
      ).length > 0
        ? false
        : true;
    }
  },
  {
    icon: 'printer',
    tooltip: 'Imprimir hoja de picking',
    type: TYPE_CONSOLIDATED.PRINT_HP,
    hasVisibleCondition: (element: Consolidated[]) => {
      return element.filter(
        (x: Consolidated) => conditionPrinterHP(x)
      ).length > 0 || !(JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code === 'SPSA')
        ? false
        : true;
    }
  },
  {
    icon: 'printer',
    tooltip: 'Imprimir',
    type: TYPE_CONSOLIDATED.PRINT,
    hasVisibleCondition: (element: Consolidated[]) => {
      return element.filter(
        (x: Consolidated) => conditionPrinter(x) && x.numberPackages === 0
      ).length > 0 || JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code === SUPERMERCADOS_CODE
        ? false
        : true;
    }
  },
  {
    icon: 'cancel',
    tooltip: 'Cancelar',
    type: TYPE_CONSOLIDATED.CANCEL,
    hasVisibleCondition: (element: Consolidated[]) => {
      return element.filter(
        (x: Consolidated) => x.state !== STATE_ORDER_DISPATCH.INCOMPLETE_PICKING
        || x.hasMultipleEntitiesSelected
      ).length > 0
        ? false
        : true;
    }
  }
];
export const consolidatedPicking:DataTable = {
  searchText: '',
  addText: '',
  checkbox: true,
  expandable: true,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  iconsOfActions: iconsOfActionsList,
  paginator: true,
  hasDisabledCheckBoxItem: (item: any) => {
    // if (VALIDATE_ROLES()) {
    //   return true;
    // }
    switch (item.state) {
      case STATE_ORDER_DISPATCH.TO_LOCATE:
      case STATE_ORDER_DISPATCH.IN_PICKING:
      case STATE_ORDER_DISPATCH.CONSOLIDATED:
      case STATE_ORDER_DISPATCH.PRE_DISPATCH:
      case STATE_ORDER_DISPATCH.INCOMPLETE_PICKING:
      case STATE_ORDER_DISPATCH.DISPATCHED:
        return false;
      case STATE_ORDER_DISPATCH.CREATED:
        const entities: EntityPicking[] = hasVisiblePickingAssignment();
        let enableAssignment = entities.find(e=>e.entityId ===item.entityCode) ? entities.find(e=>e.entityId ===item.entityCode).enableAssignment : false
        return hasVisibleAssignment() || enableAssignment ? false : true;
      default:
        return true;
    }
  },
  columns: [
    {
      title: 'N° de despacho',
      name: 'serialNumber',
      type: 'string',
      class: 'number-order-consolidated',
      sortServer: true,
      value: (element: Consolidated) =>
        element.serialNumber ? element.serialNumber : ''
    },
    {
      title: 'Tipo de doc',
      name: 'customer.documentType',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => {
        if (element.customer) {
          const document: any = Constants.Customer.DOCUMENT_TYPES.getProps(element.customer.documentType);
          return document.text;
        }
        return '-';
      }
    },
    {
      title: 'N° de doc.',
      name: 'customer.identityDocument',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.customer.identityDocument
    },
    {
      title: 'Cliente',
      name: 'customer.fullName',
      type: 'string',
      sortServer: true,
      value: (element: Consolidated) => element.customer.fullName
    },
    {
      title: 'Receptor',
      name: 'authorizedReceiver',
      type: 'string',
      sortServer: true,
      value: (element: Consolidated) => element.receiver
    },
    {
      title: 'Estado',
      name: 'stateOrderDispatch.name',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.state
    },
    {
      title: 'Fill Rate',
      name: 'fillRate',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.fillRate
    },
    {
      title: 'Fecha de despacho',
      name: 'dateDispatch',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.retirementDate
    },
    {
      title: 'Fecha de creación de despacho',
      name: 'dateCreated',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.dateCreated
    },
    {
      title: 'Fecha y hora de fin de trabajo en picking',
      name: 'consolidatedDate',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.consolidatedDate
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.startDateDeliveryWindow
    },
    {
      title: 'Fin ventana horaria',
      name: 'endDateDeliveryWindow',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.endDateDeliveryWindow
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      class: 'center',
      editable: false,
      checkAll: false,
      sortServer: true,
      value: (element: Consolidated) => element.dispatchTypeCode
    },
    {
      title: 'Modalidad de Despacho',
      name: 'methodDeliveryName',
      type: 'string',
      class: 'center',
      editable: false,
      checkAll: false,
      sortServer: false,
      value: (element: Consolidated) => element.methodDeliveryName
    },
    {
      title: 'N° Paquetes',
      name: 'amountContainer',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.numberPackages ? element.numberPackages : '-'
    },
    {
      title: 'Medio de pago',
      name: 'paymentMethodName',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.paymentMethodName ==='null'? '' : element.paymentMethodName
    },
    {
      title: 'Canal de venta',
      name: 'saleChannel',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.saleChannel ? element.saleChannel: ""
    },
    {
      title: 'Fecha máxima de carga',
      name: 'datePicking',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.datePicking ? element.datePicking: ""
    },
    {
      title: 'Entidad final de ruta',
      name: 'lastEntityName',
      type: 'string',
      sortServer: false,
      value: (element: Consolidated) => element.lastEntityName ? element.lastEntityName : ""
    },
    {
      title: 'Tiempo transcurrido (horas)',
      name: 'timeElapsed',
      type: 'string',
      class: 'center',
      sortServer: false,
      value: (element: Consolidated) => element.timeElapsed ? element.timeElapsed : ""
    },
    {
      title: 'N° de Skus',
      name: 'numberOfSkus',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.numberOfSkus
    },
    {
      title: 'Estado de pago',
      name: 'paymentStatus',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.paymentStatus
    },
    {
      title: 'Monto total',
      name: 'totalAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.totalAmount
    },
    {
      title: 'Motivo de cancelación',
      name: 'cancellationReason',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.cancellationReason
    },
    {
      title: 'Agrupación de entidad actual',
      name: 'groupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.groupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.finalGroupName
    },
    {
      title: 'Imagen',
      type: 'button',
      name: 'image',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => {
        return {
          icon: 'photo',
          svg: true,
          tooltip: 'Ver detalles del producto',
          class: 'recordColumn icon-table'
        };
      }
    }
  ]
};
